module.exports = __webpack_public_path__ + "static/media/5.1cc9328c.jpg";